

import { cityService } from "@/services/city.service";
import CityModel from "../models/city";
import {Component, Vue, Watch} from "vue-property-decorator";
import { VForm } from '@/types';
import { authService } from "@/services/authentification.service";
import ConfirmComponent from "@/components/ConfirmComponent.vue";
import {Filter, Sort} from "@/models/common";
import { DataOptions } from "vuetify";

@Component({
  components: { ConfirmComponent }
})
export default class City extends Vue {
  private cities: Array<CityModel> = new Array<CityModel>();
  private editedItem = new CityModel();
  private defaultItem = new CityModel();

  private displayEditDialog = false;
  private displayConfirmDialog = false;
  private editedIndex = -1;
  private totalCities = 0;
  private loading = true;

  private pagination = {
    page: 1,
    itemsPerPage: 50,
    pageStart: 0,
    pageStop: 50,
    pageCount: 0,
    itemsLength: 0,
  };

  private options: DataOptions = {
    itemsPerPage: 50,
    page: 1,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false
  };

  private saveLoading = false;
  private deleteLoading = false;

  private headers = [
    { text: "Название", value: "name", sortable: false },
    { text: "Действия", value: "actions", sortable: false },
  ];

  private valid = true;

  async created() {
    const employee = await authService.getCurrentUser();
    if (employee?.role?.name === "Root") {
      this.headers.unshift({text: "Ид", sortable: false, value: "id"});
    }
  }

  @Watch("options", {deep: true})
  async loadCities() {
    try {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const offset = (page - 1) * itemsPerPage;
      const count = itemsPerPage == -1 ? this.totalCities : itemsPerPage;
      const sorts = new Array<Sort>();
      const filters = new Array<Filter>();

      this.pagination.pageStart = offset;
      this.pagination.pageStop = offset + itemsPerPage;

      const res = await cityService.getPageData(offset, count, sorts, filters);
      this.cities = res.data.collection;
      this.totalCities = res.data.count;
      this.pagination.itemsLength = res.data.count;
      this.pagination.pageCount = Math.ceil(res.data.count / 50);
    }
    catch (ex) {
      this.$toast.error("Ошибка при загрузке данных");
    }
    this.loading = false;
  }

  showEditDialog(item: CityModel) {
    this.editedIndex = this.cities.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayEditDialog = true;
  }

  showDeleteDialog(item: CityModel) {
    this.editedIndex = this.cities.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayConfirmDialog = true;
  }

  async deleteCity() {
    try {
      this.deleteLoading = true;
      const item = this.editedItem;
      await cityService.delete(item.id);
      await this.loadCities();
    }
    catch (ex) {
      this.$toast.error("Ошибка при удалении");
    }
    this.deleteLoading = false;
    this.close();
  }

  close() {
    this.displayConfirmDialog = false;
    this.displayEditDialog = false;
    this.form?.resetValidation();
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  get form(): VForm {
    return this.$refs.form as VForm;
  }

  async save() {
    this.form?.validate();
    if (this.valid) {
      this.saveLoading = true;
      const index = this.editedIndex;
      try {
        if (index > -1) {
          await cityService.update(this.editedItem);
        } else {
          await cityService.create(this.editedItem);
        }
        await this.loadCities();
      }
      catch (ex) {
          this.$toast.error("Ошибка при сохранении");
      }
      this.saveLoading = false;
      this.close();
    }
  }
}
